export default "__VITE_ASSET__BMdDF_Cd__"